import { latestUpdates } from '@/mocks/manhwa';

export default function LatestUpdates() {
  return (
    <section id="update" className="bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mb-8 flex items-center justify-between">
          <div>
            <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">最新更新</h2>
            <p className="mt-2 text-sm text-foreground-600">各汉化组熟肉同步上线，连载进度一目了然。</p>
          </div>
          <span className="hidden items-center gap-2 rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-800 sm:inline-flex">
            <i className="ri-refresh-line" />
            实时同步
          </span>
        </div>

        <div className="overflow-hidden rounded-lg bg-background-50">
          <ul className="divide-y divide-background-100">
            {latestUpdates.map((u, i) => (
              <li key={i}>
                <button className="flex w-full flex-wrap items-center gap-3 px-4 py-4 text-left transition-colors hover:bg-primary-50 md:px-5">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary-50 text-xs font-bold text-primary-700">
                    {i + 1}
                  </span>
                  <span className="min-w-0 flex-1 font-bold text-foreground-950">{u.title}</span>
                  <span className="whitespace-nowrap text-sm text-secondary-700">{u.chapter}</span>
                  <span className="rounded bg-background-100 px-2 py-0.5 text-xs text-foreground-600">{u.group}</span>
                  <span className="hidden whitespace-nowrap text-xs text-foreground-500 sm:inline">{u.time}</span>
                </button>
              </li>
            ))}
          </ul>
        </div>

        <p className="mt-4 text-center text-xs text-foreground-500">
          以上为最近 24 小时更新精选，更多连载请在"热门连载"中继续探索。
        </p>
      </div>
    </section>
  );
}